import { endPoints } from '../../Config';
import { handleDeleteRequest } from '../../service/DeleteTemplate';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePatchRequest } from '../../service/PatchTemplate';
import { handlePostRequest } from '../../service/PostTemplate';

const buildQueryString = (filters = {}) => {
    const params = new URLSearchParams();

    Object.entries(filters || {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;

        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && item !== '') params.append(key, item);
            });
            return;
        }

        params.append(key, value);
    });

    return params.toString();
};

const withQuery = (endpoint, filters = {}) => {
    const query = buildQueryString(filters);
    return query ? `${endpoint}?${query}` : endpoint;
};

export const getOkrCycles = () => handleGetRequest(endPoints.okrCycles, true);

export const getOkrCycle = (cycleId) => handleGetRequest(`${endPoints.okrCycles}/${cycleId}`, true);

export const createOkrCycle = (payload) => handlePostRequest(payload, endPoints.okrCycles, true);

export const updateOkrCycle = (cycleId, payload) => handlePatchRequest(payload, `${endPoints.okrCycles}/${cycleId}`, true);

export const previewOkrCycleCopy = (cycleId, payload) => handlePostRequest(payload, `${endPoints.okrCycles}/${cycleId}/copy-preview`, false, false, true);
export const copyOkrCycle = (cycleId, payload) => handlePostRequest(payload, `${endPoints.okrCycles}/${cycleId}/copy`, true, false, true);

export const lockOkrWeek = (cycleId, weekNumber, payload) =>
    handlePatchRequest(payload, `${endPoints.okrCycles}/${cycleId}/weeks/${weekNumber}/lock`, true);

export const closeOkrCycle = (cycleId) => handlePatchRequest({}, `${endPoints.okrCycles}/${cycleId}/close`, true);

export const getOkrTeams = (cycleId) => handleGetRequest(withQuery(endPoints.okrTeams, { cycleId }), true);

export const createOkrTeam = (payload) => handlePostRequest(payload, endPoints.okrTeams, true);

export const updateOkrTeam = (teamId, payload) => handlePatchRequest(payload, `${endPoints.okrTeams}/${teamId}`, true);

export const deleteOkrTeam = (teamId) => handleDeleteRequest(`${endPoints.okrTeams}/${teamId}`, true);

export const getOkrObjectives = (filters = {}) => handleGetRequest(withQuery(endPoints.okrObjectives, filters), true);

export const createOkrObjective = (payload) => handlePostRequest(payload, endPoints.okrObjectives, true);

export const updateOkrObjective = (objectiveId, payload) =>
    handlePatchRequest(payload, `${endPoints.okrObjectives}/${objectiveId}`, true);

export const deleteOkrObjective = (objectiveId) => handleDeleteRequest(`${endPoints.okrObjectives}/${objectiveId}`, true);

export const getOkrKeyResults = (filters = {}) => handleGetRequest(withQuery(endPoints.okrKeyResults, filters), true);

export const createOkrKeyResult = (payload) => handlePostRequest(payload, endPoints.okrKeyResults, true);

export const updateOkrKeyResult = (keyResultId, payload) =>
    handlePatchRequest(payload, `${endPoints.okrKeyResults}/${keyResultId}`, true);

export const deleteOkrKeyResult = (keyResultId) => handleDeleteRequest(`${endPoints.okrKeyResults}/${keyResultId}`, true);

export const syncOkrKeyResultWeek = (keyResultId, payload) =>
    handlePostRequest(payload, endPoints.okrKeyResultSyncWeek(keyResultId), true);

export const getOkrWeeklyEntries = (filters = {}) => handleGetRequest(withQuery(endPoints.okrWeeklyEntries, filters), true);

export const createOrUpdateOkrWeeklyEntry = (payload) => handlePostRequest(payload, endPoints.okrWeeklyEntries, true);

export const updateOkrWeeklyEntry = (entryId, payload) =>
    handlePatchRequest(payload, `${endPoints.okrWeeklyEntries}/${entryId}`, true);

export const approveOkrWeeklyEntry = (entryId) => handlePatchRequest({}, `${endPoints.okrWeeklyEntries}/${entryId}/approve`, true);

export const rejectOkrWeeklyEntry = (entryId, payload) =>
    handlePatchRequest(payload, `${endPoints.okrWeeklyEntries}/${entryId}/reject`, true);

export const overrideOkrWeeklyEntry = (entryId, payload) =>
    handlePatchRequest(payload, `${endPoints.okrWeeklyEntries}/${entryId}/override`, true);

export const getOkrDashboard = (cycleId) => handleGetRequest(withQuery(endPoints.okrDashboard, { cycleId }), true);

export const getOkrScoreboard = (cycleId) => handleGetRequest(withQuery(endPoints.okrScoreboard, { cycleId }), true);

export const getQuickBooksFinancialIndicators = (filters = {}) =>
    handleGetRequest(withQuery(endPoints.quickbooksFinancialIndicators, filters), false);

export const getOkrFinancialTargets = (cycleId, businessUnit) => handleGetRequest(withQuery(`${endPoints.okrCycles}/${cycleId}/financial-targets`, { businessUnit }), false);
export const saveOkrFinancialTargets = (cycleId, businessUnit, payload) => handlePatchRequest(payload, withQuery(`${endPoints.okrCycles}/${cycleId}/financial-targets`, { businessUnit }), false, false);
